module.exports = __webpack_public_path__ + "img/claro-logo.1ccb224f.png";